import { register } from "../../../JavaScript/Utils";
import { TrackingHelper } from "../../../JavaScript/TrackingHelper";
import { FormDetails} from "./FormDetails.interface";
// @ts-expect-error There are no TS definitions available for captcha-eu-sdk
import {KROT} from 'captcha-eu-sdk';

export const FormAjax = (el: HTMLElement) => {
  const baseUrl: string = window.location.origin;
  const path: string = window.location.pathname;
  const type: string = "1439553600";

  function init(): void {
    const formContainers = el.querySelectorAll('.frame-type-form_formframework');

    formContainers.forEach((container: HTMLElement): void => {
      initializeAjaxForm(container);
    })
  }

  async function initializeAjaxForm(formContainer: HTMLElement) {
    const form = formContainer.querySelector('form');

    if (!form) {
      return;
    }

    const id = +form.id.replace(/.+-(\d+)$/g, '$1');

    const formDetails: FormDetails = {
      id: id,
      path: path,
      type: type,
      baseUrl: baseUrl
    };

    formContainer.addEventListener('click', async (event: MouseEvent): Promise<void> => {
      await handleSuccessPageCloseEvent(event, formContainer, formDetails);
      await handleBackButtonClickEvent(event, formContainer, id);
    });

    formContainer.addEventListener('change', async (event: Event): Promise<void> => {
      handleOriginSelectChangeEvent(event, formContainer);
    });

    formContainer.addEventListener('submit', async (event: SubmitEvent): Promise<void> => {
      await handleFormSubmitEvent(event, id, formContainer);
    });
  }

  async function handleSuccessPageCloseEvent(event: MouseEvent, container: HTMLElement, config: FormDetails): Promise<void> {
    if (! (event.target instanceof HTMLButtonElement) || event.target.dataset.buttonCloseType !== 'successMessage') {
      return;
    }

    const response = await fetch(
      `${config.baseUrl}${config.path}?type=${config.type}&form_id=${config.id}&tx_form_formframework%5Baction%5D=perform`
    );
    if (response.ok) {
      const formSubmitResponse = await response.text();
      const doc = new DOMParser().parseFromString(formSubmitResponse, "text/html");
      container.innerHTML = doc.querySelector('#c' + config.id).innerHTML;
    }
  }

  async function handleBackButtonClickEvent(
    event: MouseEvent,
    formContainer: HTMLElement,
    id: number
  ): Promise<void> {
    if (! (event.target as HTMLElement).classList.contains('btn-previous')) {
      return;
    }
    event.preventDefault();

    const form = formContainer.querySelector('form');

    if (form.classList.contains('ajax-processing')) {
      return;
    }

    form.querySelector(`button[name="tx_form_formframework[${form.getAttribute('id')}][__currentPage]"]`).setAttribute(
      'value',
      form.querySelector(`[type="hidden"][name="tx_form_formframework[${form.getAttribute('id')}][__currentPage]"]`).getAttribute('value')
    );
    const response: Response = await submitForm(form, id);

    await handleSuccessResponse(response, formContainer, id);
  }

  function handleOriginSelectChangeEvent(event: Event, formContainer: HTMLElement) {
    const select = event.target as HTMLSelectElement;
    const originFieldset: HTMLElement = formContainer.querySelector('fieldset[id*="fieldset_ss_origin_other"]');

    if (select.getAttribute('name').indexOf('[ss_origin') === -1 || originFieldset === null) {
      return;
    }
    const selectedValue = select.value;
    const lastElementValue = select.options[select.options.length - 1].value;

    originFieldset.style.display = selectedValue === lastElementValue ? 'block' : 'none';
  }

  async function handleFormSubmitEvent(event: SubmitEvent, id: number, formContainer: HTMLElement) {
    const form: HTMLFormElement = event.target as HTMLFormElement;
    event.preventDefault();

    if (form.classList.contains('ajax-processing')) {
      return;
    }

    const response: Response = await submitForm(form, id);
    await handleSuccessResponse(response, formContainer, id);
  }

  async function handleSuccessResponse(response: Response, formContainer: HTMLElement, formId: number): Promise<void> {
    if (! response.ok) {
      formContainer.querySelector('form').classList.remove('ajax-processing');
      return;
    }

    if (response.redirected) {
      setTimeout(() => {
          window.location.href = response.url;
        }, 1000
      );
      return;
    }

    const formSubmitResponse = await response.text();
    const doc = new DOMParser().parseFromString(formSubmitResponse, "text/html");
    formContainer.innerHTML = doc.querySelector('#c' + formId).innerHTML;
  }

  async function submitForm(form: HTMLFormElement, id: number): Promise<Response> {
    form.classList.add('ajax-processing');

    const submitButton: HTMLButtonElement = form.querySelector(
      '[type="submit"][name^="tx_form_formframework[' + form.getAttribute('id') + ']"]'
    );

    const isFinalSubmit = submitButton.parentElement.classList.contains('submit');

    await solveCaptchaIfConfigured(form);

    const formData: FormData = new FormData(form);
    formData.append(
      submitButton.getAttribute('name'),
      submitButton.getAttribute('value')
    );

    const response = await fetch(
      `${baseUrl}${path}?type=${type}&form_id=${id}&tx_form_formframework%5Baction%5D=perform`,
      { method: form.getAttribute("method"), body: formData }
    );

    if (isFinalSubmit) {
      (new TrackingHelper()).trackFormSubmit(form, response);
    }

    return response;
  }

  async function solveCaptchaIfConfigured(form: HTMLFormElement): Promise<void> {
    const captchaField: HTMLInputElement = form.querySelector(`#${form.getAttribute('id')}-captchaeu-1`);
    if (!captchaField) {
      return;
    }

    KROT.setup(captchaField.dataset.publickey);
    KROT.KROT_HOST = captchaField.dataset.host;

    await KROT.getSolution().then((sol: any) => {
      captchaField.value = JSON.stringify(sol);
    });
  }

  init();
}

register("FormAjax", FormAjax);
